import styled from "styled-components";
import Modal from "react-modal";

export const StyledReactModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 1rem;
  background: white;
  overflow: auto;
  outline: none;

  @media (max-width: 960px) {
    width: 90%;
    padding: 1.5rem;
  }
`;